// slices/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userId: null,
  cabRequest : [],
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserId: (state, action) => {
      state.userId = action.payload;
    },

    setCabRequests : (state,action)=>{
      state.cabRequest = action.payload;
    }
  },
});

export const { setUserId,setCabRequests } = userSlice.actions;

export default userSlice.reducer;
